import React, { useCallback, useMemo } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { IProductInsideCombo } from 'src/types/combo';
import { formatUnit, getTranslate } from 'src/utils/formatter';
import { getComboItemUnavailableMessage } from 'src/utils/helpers';
import { getProductUnits } from 'src/utils/product';
import ImageSlider from 'src/view/components/ImageSlider/ImageSlider';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import '../MealComboItemModal/style.scss';
import './style.scss';

interface IProps {
  item: IProductInsideCombo;
  isMeal?: boolean;
  selectItem?: (item: IProductInsideCombo) => void;
  clickClose: () => void;
}

const DealComboItemModal: React.FC<IProps> = (props: IProps): JSX.Element => {
  const hanldeSelect = useCallback(() => {
    if (props.selectItem) props.selectItem(props.item);
    props.clickClose();
  }, [props.item, props.selectItem]);

  const isSelect: boolean = Boolean(!props.isMeal || props.item.is_selected);
  const unavailableMessage: string | undefined = getComboItemUnavailableMessage(props.item);

  const units = useMemo(() => getProductUnits(props.item), [props.item]);
  const description: string | undefined = [...units, getTranslate(props.item.description)].filter(Boolean).join(' • ');

  return (
    <div className="d-flex flex-column flex-grow-1 full-height">
      <div className="deal-combo-item-modal__image-wrapper">
        <ImageSlider
          images={props.item.images || [props.item.image]}
          aspectRatio={295 / 250}
          sliderClassName={`deal-combo-item-modal__image ${
            unavailableMessage ? 'meal-combo-item-modal__unavailable' : ''
          }`}
        />
        {unavailableMessage ? (
          <p className="meal-combo-item-modal__unavailable-message family-bold color-red text-size-16">
            {localeStore.t(unavailableMessage)}
          </p>
        ) : null}
      </div>
      <div className="deal-combo-item-modal__bottom-block full-height">
        <div className="d-flex flex-column deal-combo-item-modal__text-wrapper">
          <div className="deal-combo-item-modal__block-name">
            <p className="deal-combo-item-modal__name family-bold color-dark text-size-20">
              {getTranslate(props.item.name)}
            </p>
            {/* <p className="deal-combo-item-modal__unit family-regular color-gray text-size-12 ml-3">
              {formatUnit(props.item.unit_name, props.item.weight)}
            </p> */}
          </div>
          <ScrollableBlock showScrollbar scrollbarSize="small" className="deal-combo-item-modal__scroll">
            <p className="deal-combo-item-modal__description family-regular color-dark text-lite-elipsis">
              {description}
            </p>
          </ScrollableBlock>
        </div>
        <div
          className={`deal-combo-item-modal__btn-selected background${isSelect ? '_pseudo-primary' : '-primary'}`}
          onClick={hanldeSelect}
        >
          <p
            className={`deal-combo-item-modal__btn-selected_text family-semibold color-${
              isSelect ? 'primary' : 'white'
            }`}
          >
            {localeStore.t(isSelect ? 'selected' : 'select')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(DealComboItemModal);
